import { render, staticRenderFns } from "./CollectCoupons.vue?vue&type=template&id=4d2ec958&scoped=true"
import script from "./CollectCoupons.vue?vue&type=script&lang=js"
export * from "./CollectCoupons.vue?vue&type=script&lang=js"
import style0 from "./CollectCoupons.vue?vue&type=style&index=0&id=4d2ec958&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d2ec958",
  null
  
)

export default component.exports